import styled, { css } from 'styled-components';
import { blue, white } from 'theme/colors';
import { spacing1x, spacing2x } from 'theme/spacings';
import { FiGlobe, FiChevronDown, FiChevronUp } from 'react-icons/fi';

export const GlobeIcon = styled(FiGlobe)`
	color: ${(props) => (props.isLindabGroup ? white : blue)};
	margin-right: ${spacing1x};
	position: absolute;
	display: inline-block;
	width: 1.8rem;
	top: 50%;
	transform: translateY(-50%);
	@media (max-width: 1150px) {
		top: 0.4rem;
		left: 1rem;
		position: relative;
		transform: none;
	}
`;

const arrowStyling = css`
	position: relative;
	top: ${spacing2x};
	margin-left: ${spacing1x};
	display: inline-block;
	transform: translateY(-50%);
	width: 1.8rem;
`;

export const ArrowUp = styled(FiChevronUp)`
	${arrowStyling};
	color: ${(props) => (props.isLindabGroup ? white : blue)};
`;
export const ArrowDown = styled(FiChevronDown)`
	${arrowStyling};
	color: ${(props) => (props.isLindabGroup ? white : blue)};
`;
